import "./header-actions.less";
import template from "./header-actions.html";
import { EVENT_NEW_FORM } from "../../constants";

function controller(
	uiState,
	appState,
	$uibModal,
	eventBus,
	$scope,
	noticeService,
	$logger
) {

	const ctrl = this;
	ctrl.uiState = uiState;
	ctrl.$onInit = onInit;
	ctrl.openSettingsModal = () => openModal("settings-modal", "md");
	ctrl.openAccessibilityModal = () => openModal("accessibility-modal", "md");
	ctrl.openHelpModal = () => openModal("support-info-modal", "md");
	ctrl.openAccountModal = () => openModal("user-profile-modal", "md");
	ctrl.openNoticesModal = () => openModal("notices-modal", "md");

	function onInit() {
		ctrl.inNav = !!ctrl.inNav;
		ctrl.forms = appState.forms.items;
		ctrl.form = appState.forms.selected;
		ctrl.permissions = appState.permissions;
		refreshDataFromService();

		eventBus.register(
			EVENT_NEW_FORM,
			() => {
				ctrl.form = appState.forms.selected;
			},
			$scope
		);

		$scope.$watch(() => noticeService.notices, (next, prev) => {
			if(next !== prev) {
				refreshDataFromService(next);
			}
		});
	}

	function refreshDataFromService(notices) {
		ctrl.notices = notices ?? noticeService.notices;
		ctrl.hasNewNotices = noticeService.hasUnreadNotices;
	}

	function openModal(modalName, size = "lg", resolve = {}) {

		closeSidebar();
		
		$uibModal.open({
			component: modalName,
			size: size,
			resolve: resolve
		});
	}

	function closeSidebar() {
		ctrl.uiState.sidebar.open = false;
	}
}

export default angular
	.module("vesl.components.header-actions", [])
	.component("headerActions", {
		template,
		controller,
		bindings: {
			inNav: "<"
		}
	}).name;